import { useNavigate } from 'react-router';

export const useGoBack = () => {
  const navigate = useNavigate();

  return () => navigate('..', { relative: 'path' });
};
